module.exports = __webpack_public_path__ + "img/43a8073.svg";